import { differenceInDays, parseISO } from 'date-fns';
/**
 * Calculates Nominal APR based on early payment discount terms
 * Formula: (Discount / 100) / (1 - Discount/100) * 360 / daysDiff
 *
 * @param terms - Payment terms containing discount, due date, and discount expiration
 * @returns APRResult if calculation is possible, null otherwise
 */
export function calculateNominalAPR(terms) {
    const { discount, dueDate, discountExpiration } = terms;
    // Validate required fields
    if (discount === null || discount === undefined || !dueDate || !discountExpiration) {
        return null;
    }
    // Calculate days between discount expiration and due date
    const daysDiff = differenceInDays(parseISO(dueDate), parseISO(discountExpiration));
    if (daysDiff <= 0)
        return null;
    // Apply formula
    const discountDecimal = discount / 100;
    const apr = (discountDecimal / (1 - discountDecimal)) * (360 / daysDiff);
    return {
        value: apr,
        formatted: `${(apr * 100).toFixed(2)}%`
    };
}
/**
 * Placeholder for Adjusted APR calculation
 * To be implemented when formula is defined
 *
 * @param terms - Payment terms containing discount, due date, and discount expiration
 * @returns APRResult if calculation is possible, null otherwise
 */
export function calculateAdjustedAPR(terms) {
    // TODO: Implement when formula is defined
    return null;
}
/**
 * Calculate potential savings from taking early payment discount
 * Useful for Early Pay module charts
 *
 * @param totalAmount - Invoice total amount
 * @param discountPercent - Discount percentage
 * @returns Discount amount in currency, or null if inputs are invalid
 */
export function calculateDiscountAmount(totalAmount, discountPercent) {
    if (totalAmount === null || discountPercent === null)
        return null;
    return totalAmount * (discountPercent / 100);
}
//# sourceMappingURL=earlyPay.js.map